<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadTaskCategories(1, null, true)">

      <template slot="actions">
        <vs-input :placeholder="$t('category_name')" v-model="taskCategoryFormData.name" class="configuration-task-category-name-input" />
        <vx-input-group>
          <vs-input :placeholder="$t('description')" v-model="taskCategoryFormData.description" class="configuration-task-category-description-input" />
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button id="addConfigurationTaskCategoryButton" color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addTaskCategory">{{ $t('add_category') }}</vs-button>
            </div>
          </template>
        </vx-input-group>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('category_name')" v-model="taskCategorySearchParams.name" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('description')" v-model="taskCategorySearchParams.description" class="w-full"/>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadTaskCategories(1, null, true)" v-text="$t('search')"></vs-button>
      </template>

    </vx-card>

    <vx-card id="taskCategoryDataContainer" :title="$t('category')" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-configuration-tab-nav></shared-configuration-tab-nav>
      </template>

      <shared-user-configuration-task-category-list
        :taskCategories="taskCategories"
        @customClickEdit="edit"
        @customClickDelete="destroy"
        @customClickSave="save"
        @customClickCancel="cancel"
      ></shared-user-configuration-task-category-list>

      <template slot="footer">
        <paginate
          :total="taskCategoryPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadTaskCategories"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>
  </div>
</template>

<script>
import SharedConfigurationTabNav from '@/views/Shared/Configuration/TabNav'
import TaskCategory from '@/models/TaskCategory'
import SharedUserConfigurationTaskCategoryList from '@/views/Shared/Configuration/Task/Categories/List'
import Paginate from '@/mixins/paginate'

export default {
  name: 'User.Configuration.Task.Categories',
  mixins: [Paginate],
  components: {
    SharedConfigurationTabNav,
    SharedUserConfigurationTaskCategoryList
  },
  data () {
    return {
      taskCategoriesEdit: {},
      taskCategories: {},
      taskCategoryPages: 1,
      taskCategoryFormData: {
        name: '',
        description: '',
        id: ''
      },
      taskCategoryFormErrors: {},
      itemPerPage: null,
      taskCategorySearchParams: {
        name: typeof this.$route.query.name !== 'undefined' ? this.$route.query.name : '',
        description: typeof this.$route.query.description !== 'undefined' ? this.$route.query.description : ''
      }
    }
  },
  mounted () {
    this.loadTaskCategories(this.initialPage, null, false, true)
  },
  methods: {
    async loadTaskCategories (page = 1, itemPerPage = null, backToPageOne = false, isOnLoad = false) {
      this.$vs.loading({container: '#taskCategoryDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      if (!isOnLoad) {
        this.$router.replace({query: { ...this.taskCategorySearchParams, page, itemPerPage }})
      }
      const response = await TaskCategory.all({ ...this.taskCategorySearchParams, page, itemPerPage })
      this.taskCategories = response.data.data.taskCategories
      this.taskCategoryPages = response.data.meta.pagination.last_page
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#taskCategoryDataContainer > .con-vs-loading')
    },
    async addTaskCategory (e) {
      e.preventDefault()
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addConfigurationTaskCategoryButton', scale: 0.45})
      if (this.taskCategoryFormData.name.trim().length === 0 && this.taskCategoryFormData.description.trim().length === 0) {

        await this.$swalHelper.error({
          title: '',
          text: this.$t('add_task_category_error_message_if_empty_category_name_and_empty_description'),
          confirmButton: this.$t('confirm')
        })

      } else if (this.taskCategoryFormData.name.trim().length === 0) {

        await this.$swalHelper.error({
          title: '',
          text: this.$t('add_task_category_error_message_if_empty_category_name'),
          confirmButton: this.$t('confirm')
        })

      } else if (this.taskCategoryFormData.description.trim().length === 0) {

        await this.$swalHelper.error({
          title: '',
          text: this.$t('add_task_category_error_message_if_empty_description'),
          confirmButton: this.$t('confirm')
        })

      } else if (!this.$store.getters.isFormInProgress) {
        this.$store.dispatch('setIsFormInProgress', true)
        await TaskCategory.save(this.taskCategoryFormData)
        this.$store.dispatch('setIsFormInProgress', false)
        this.loadTaskCategories(1, this.itemPerPage)
        this.taskCategoryFormData = {
          name: '',
          description: '',
          id: ''
        }
        this.taskCategoryFormErrors = {}
      }
      this.$vs.loading.close('#addConfigurationTaskCategoryButton > .con-vs-loading')
    },
    async edit (key) {
      this.taskCategories[key].edit = true
      const editElem = this.taskCategories[key]
      const editObj = {
        name: editElem.name,
        description: editElem.description
      }
      this.taskCategoriesEdit[key] = editObj
    },
    async cancel (key) {
      this.taskCategories[key].name = this.taskCategoriesEdit[key].name
      this.taskCategories[key].description = this.taskCategoriesEdit[key].description
      this.taskCategories[key].edit = false
      this.taskCategories[key].taskCategoryFormErrors = {}
      delete this.taskCategoriesEdit[key]
    },
    async save (key, id) {
      this.$vs.loading({background: 'primary', color: '#fff', container: `#updateConfigurationTaskCategoryButton${ id }`, scale: 0.45})
      try {
        await TaskCategory.update(this.taskCategories[key])
        this.taskCategories[key].edit = false
        this.taskCategories[key].taskCategoryFormErrors = {}
      } catch (e) {
        this.taskCategories[key].taskCategoryFormErrors = e.response.data.errors
      }
      this.$vs.loading.close(`#updateConfigurationTaskCategoryButton${ id } > .con-vs-loading`)
    },
    async destroy (key, id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        await TaskCategory.delete(id)
        this.loadTaskCategories(1, this.itemPerPage)
      }
    }
  }
}
</script>

<style lang="scss">
  #addConfigurationTaskCategoryButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
